import styled from "styled-components";
import tw from "twin.macro";
import BlockText from "../../block-content/block-text";

const TextStyles = styled.div`
  p,
  span {
    ${tw`tracking-tighter font-bold leading-snug text-lg`}
    display: inline
  }
  span {
    ${tw`text-base`}
  }
`;

/**
 * InfographicBlock primarily used for stats
 * @param {string} type
 * @param {string} theme
 * @param {string} title
 * @param body
 * @param {string} source
 * @returns {JSX.Element}
 * @constructor
 */
const InfographicBlock = (props) => {

  const {
    type = "standard",
        theme = "blue",
        title,
        _rawBody,
        source,
        link,
        section
  } = props

  const wrapperClass = getWrapperClass(theme);
  const prefix = getPrefix(type);
  const infix = getInfix(type);
  const suffix = getSuffix(type);
  const hasLink = link?.href || link?.reference?.path;
  let titleParts = [];
  if (infix) {
    titleParts = title.split("of");
  }

  return (
      <div
      className={`${wrapperClass}${hasLink ? " cursor-pointer" : ""}`}
      onClick={(evt) => {
        if (hasLink) {
          evt.preventDefault();
          let url = link?.href || link.reference?.path || link.reference.slug.current
          if (link?.reference?.sections) {
            url = `/news${section}${url}`
          }
          window.location.href = url;

        }
      }}
    >
      <h3
        className="font-mono text-6xl font-bold leading-none tracking-tighter"
        style={{ fontSize: 75 }}
      >
        {prefix && <span className={prefix.className}>{prefix.value}</span>}
        {infix ? titleParts[0] : title}
        {infix ? <span className={infix.className}>{infix.value}</span> : ""}
        {infix ? titleParts[1] : ""}
        {suffix && <span className={suffix.className}>{suffix.value}</span>}
      </h3>
      {_rawBody && (
        <TextStyles>
          <BlockText blocks={_rawBody} />
          {source && <span> — {source}</span>}
        </TextStyles>
      )}
    </div>
  );
};

/**
 * Get Prefix settings
 * @param {string} type
 * @returns {null|Object}
 */
function getPrefix(type) {
  let prefix = null;

  switch (type) {
    case "top":
      prefix = {
        className:
          "font-sans text-base font-bold align-middle mr-1 tracking-wide uppercase",
        value: "Top",
      };
      break;
    case "number":
      prefix = {
        className: "text-5xl align-baseline",
        value: "No. ",
      };
      break;
    case "billion-dollars":
      prefix = {
        className: "text-5xl align-baseline",
        value: "$",
      };
      break;
    case "million-dollars":
      prefix = {
        className: "text-5xl align-baseline",
        value: "$",
      };
      break;
    case "thousand-dollars":
      prefix = {
        className: "text-5xl align-baseline",
        value: "$",
      };
      break;
    default:
      prefix = {
        className: "",
        value: "",
      };
      break;
  }

  return prefix;
}

/**
 * Get Infix settings
 * @param type
 * @returns {null|Object}
 */
function getInfix(type) {
  let infix = null;

  switch (type) {
    case "aofb":
      infix = {
        className: "font-mono ml-1 text-5xl font-bold align-baseline",
        value: "of",
      };
      break;
    default:
      break;
  }
  return infix;
}

/**
 * Get Suffix settings
 * @param type
 * @returns {null|Object}
 */
function getSuffix(type) {
  let suffix = null;

  switch (type) {
    case "percentage":
      suffix = {
        className: "font-sans ml-1 text-4xl font-bold align-baseline",
        value: "%",
      };
      break;
    case "billion-dollars":
      suffix = {
        className: "text-5xl align-baseline",
        value: "B",
      };
      break;
    case "million-dollars":
      suffix = {
        className: "text-5xl align-baseline",
        value: "M",
      };
      break;
    case "thousand-dollars":
      suffix = {
        className: "text-5xl align-baseline",
        value: "K",
      };
      break;
    case "plus":
      suffix = {
        className: "text-5xl align-baseline",
        value: "+",
      };
      break;
    case "multiplier":
      suffix = {
        className: "text-5xl align-baseline",
        value: "X",
      };
      break;
    default:
      break;
  }

  return suffix;
}

/**
 * Get wrapper class for data block
 * @param {string} theme
 */
function getWrapperClass(theme) {
  let wrapperClass = "bg-blue-500";

  switch (theme) {
    case "blue":
      wrapperClass = "bg-blue-500";
      break;
    case "teal":
      wrapperClass = "bg-teal-500 text-teal-900";
      break;
    case "yellow":
      wrapperClass = "bg-yellow-500 text-blue-500";
      break;
    case "dark-gray":
      wrapperClass = "bg-gray-700 text-white";
      break;
    default:
      break;
  }

  return `infographic-block p-4 ${wrapperClass} text-white shadow-xl md:flex-1`;
}

export default InfographicBlock;
